import { Pressable, Text } from "react-native";
import { useSlot, useStyled } from "use-styled";

const SubjectTabRoot = useStyled(Pressable, {
  base: {
    className: "flex-1 items-center",
  },
});

const SubjectTitle = useStyled(Text, {
  base: {
    className: "px-4 py-2 w-full text-center text-[16px] font-geologica-regular font-medium text-gray-800 border-b-2 border-gray-200",
  },
    variants: {
        intent: {
            active: { className: "text-teal-600 border-teal-600" },
        }
    },
});

export const SubjectTab = useSlot(SubjectTabRoot, {
  Title: SubjectTitle,
});